import { Participant, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface IParticipantContext {
    data?: Participant;
    code?: string;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<Participant | undefined>
}

export const ParticipantContext = createContext<IParticipantContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<Participant | undefined>(res => {
            res(undefined);
        });
    }
});

export default ParticipantContext;